
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Contact from '../pages/contact/page';
import Gallery from '../pages/gallery/page';
import News from '../pages/news/page';
import Admissions from '../pages/admissions/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/admissions',
    element: <Admissions />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/gallery',
    element: <Gallery />,
  },
  {
    path: '/news',
    element: <News />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
